module.exports = __webpack_public_path__ + "static/media/border.04c40522.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resource/img/border.svg
// module id = 1224
// module chunks = 0